import { EmployeeRole } from './employeeRole.data';

export enum SsoProviderType {
  MICROSOFT = 'microsoft',
  GOOGLE = 'google'
}

/** SSO Domain Configuration (structure in Firebase Database) */
export interface SsoDomainData {
  id: string;
  domain: string;
  /** Firebase auth provider ID */
  providerId: string;
  provider: SsoProviderType;
  enabled: boolean;
  companyId: string;
  /** Azure AD tenant UUID (for Microsoft SSO) */
  tenantId: string;
  includedDomains: string[];
  createDate: number;
  lastUpdate: number;
  notes: string;
}

export enum SsoUserStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  NEW = 'new'
}

export interface SsoUserBase {
  id: string;
  email: string;
  lastUpdate: number;
  /** Role set up after user acceptance */
  role: EmployeeRole | null;
  estateIds: string[];
  /** null for SsoUserStatus.NEW */
  adminId: string | null;
  displayName: string;
  createDate: number;
}

export interface SsoWhitelistData extends SsoUserBase {
  role: EmployeeRole;
  adminId: string;
  notes: string | null;
}

export interface SsoUserData extends SsoUserBase {
  /** Firebase auth provider ID */
  providerId: string;
  /** Azure AD tenant UUID (for Microsoft SSO) */
  tenantId: string;
  providerType: SsoProviderType;
  status: SsoUserStatus;
  firstLogin: number;
  lastLogin: number;
  /** Reference to the user ID from auth and users collection */
  userId: string;
}

export interface SsoEmailRequestData {
  id: string;
  userId: string;
  companyId: string;
  displayName: string;
  sendDate: number;
  receivers: string[];
}
